// extracted by mini-css-extract-plugin
module.exports = {"content":"Default_content__HO8we"};